<template>
  <div class="relative z-100">
    <Overlay :visible="isOpen" @click="close" />
    <Drawer
      ref="activeOffersSidebarRef"
      class="active-offers-sidebar__aside"
      :is-open="isOpen"
      @click:close="close"
    >
      <template #header>
        <div class="px-4 py-4 border-b border-gray-200">
          <div class="text-lg font-semibold text-gray-900">
            {{ t('general.yourRequests') }}
          </div>
        </div>
      </template>
      <LazyActiveOffersSidebarBody v-if="isOpen" />
    </Drawer>
  </div>
</template>

<script setup lang="ts">
import { useActiveOffersSidebarUiState } from '~/composables/useUiState'

const { t } = useI18n()
const { isOpen, close } = useActiveOffersSidebarUiState()
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.active-offers-sidebar__aside {
  @apply w-full sm:w-[600px] px-0 pt-0 pb-0 flex flex-col h-[100dvh];
}
</style>
